<div class="user-settings-container">
  <div class="user-perfil">
    <div>
      <div class="photo-container">
        <div class="user-photo">
          <span class="photo">{{ getInitialUsername() }}</span>
        </div>
      </div>
      <div class="user-name-perfil">
        <div class="user-name">{{ userName ? userName : usernamePlatform }}</div>
        <span>Conta: {{ accountSelected ? accountSelected : '-' }}</span>
      </div>
    </div>

    <ng-container *ngIf="configWhiteLabel.system.isMultiBroker;">
      <app-notification-bar (openExternalLink)="openExternalLink()"
                            [message]="plan" [showBtnClose]="false" [labelExternalLink]="'Ver detalhes'"></app-notification-bar>

    </ng-container>


  </div>

  <div class="user-settings-body">
    <div class="last-options">
      <h3 class="title my-2">Negociação</h3>
      <!-- <app-account-negotiation></app-account-negotiation> -->
      <div *ngIf="showNegotiation && isLoggedNegotiation"
           class="password-change last-options-item-size last-options-details" (click)="openUpdatePasswordModal()">
        <mat-icon class="last-options-icon" svgIcon="lock-outline"></mat-icon>
        <span class="option-font option-font-title">Alterar senha de acesso - negociação</span>
      </div>

      <h3 class="title my-2 mt-3">Preferências</h3>
      <div id="personal-information" class="password-change last-options-item-size last-options-details"
           (click)="openStore()" *ngIf="showUrlStore">
        <mat-icon class="last-options-icon" svgIcon="personal-information"></mat-icon>
        <span class="option-font option-font-title">Dados cadastrais</span>
      </div>
      <div id="signature-plan" class="password-change last-options-item-size last-options-details" (click)="openStore()"
           *ngIf="showUrlStore">
        <mat-icon class="last-options-icon" svgIcon="signature-plan"></mat-icon>
        <span class="option-font option-font-title">Meu plano e assinaturas</span>
      </div>
      <div id="extra-packages" class="password-change last-options-item-size last-options-details" (click)="openStore()"
           *ngIf="showUrlStore">
        <mat-icon class="last-options-icon" svgIcon="extra-packages"></mat-icon>
        <span class="option-font option-font-title">Pacotes extras</span>
      </div>
      <div *ngIf="showQuotation && isMarketDatePassword"
           class="password-change last-options-item-size last-options-details" (click)="openUpdatePasswordModal(true)">
        <mat-icon class="last-options-icon" svgIcon="lock-outline"></mat-icon>
        <span class="option-font option-font-title">Alterar senha de acesso - cotação</span>
      </div>
      <div id="change-electronic-signature" *ngIf="isWSO2 && !isAssessor"
           class="password-change last-options-item-size last-options-details" (click)="openUpdateSignature()">
        <mat-icon class="last-options-icon" svgIcon="lock-outline"></mat-icon>
        <span class="option-font option-font-title">Alterar assinatura eletrônica</span>
      </div>

      <div class="theme last-options-item-size last-options-details">
        <mat-icon class="last-options-icon color-correction" svgIcon="moon-outline"></mat-icon>
        <span class="option-font option-font-title">Tema escuro:</span>
        <span id="toggle-info" class="option-font toggle-option">{{ toggleInfo }}</span>
        <mat-slide-toggle id="toggle-theme" [(ngModel)]="darkThemeSelected" class="toggle-theme small ml-auto"  (change)="changeTheme()">
        </mat-slide-toggle>
      </div>

      <h3 class="title my-2 mt-3">Precisa de ajuda?</h3>
      <div id="user-manual" class="password-change last-options-item-size last-options-details"
           (click)="openManualOnline()">
        <mat-icon class="last-options-icon" svgIcon="ico-user-manual-outline"></mat-icon>
        <span class="option-font option-font-title">Manual do usuário</span>
      </div>
      <div id="contact-info" class="password-change last-options-item-size last-options-details"
           (click)="openSupportChannels()">
        <mat-icon class="last-options-icon" svgIcon="headphone"></mat-icon>
        <span class="option-font option-font-title">Canais de atendimento</span>
      </div>
      <div id="logout" class="quit last-options-item-size last-options-details" (click)="logout()">
        <mat-icon class="last-options-icon" svgIcon="logout-outline"></mat-icon>
        <span class="option-font option-font-title">Sair</span>
      </div>
    </div>
    <div mat-raised-button class="download-section" *ngIf="!isWSO2 && !showHelp">
      <span id="text-fast-desktop">Experimente o poder do Fast Trade no seu computador pessoal.</span>
      <div class="img-section">
        <button id="download-desktop" mat-raised-button color="primary02"><a target="_blank"
                                                                             (click)='openDownloadWindow()'>DOWNLOAD</a>
        </button>
        <a target="_blank" (click)='openDownloadWindow()'><img [src]=imgUrl/></a>
      </div>
    </div>
  </div>
</div>
